import { listChallans } from 'api/challan';
import { asyncThunkWrapper } from 'utils/AsyncThunkWrapper';

const fetchChallans = asyncThunkWrapper('challans/fetch', listChallans);

export { fetchChallans };
